import { useState } from "react";

import { ReportRun } from "../interface/ReportRun";
import { ReportRunResult } from "../interface/ReportRunResult";
import { runningResult } from "../utils/report-run";

/**
 * Running a report and saying what happened. Every panel does this the same way — open
 * the modal on a spinner, replace it with the outcome, leave it reopenable and tell the
 * card above how it went — so none of them gets to do it slightly differently.
 */
export const useReportRun = (
  onRunStateChange?: (result: ReportRunResult) => void,
): ReportRun => {
  const [open, setOpen] = useState(false);
  const [result, setResult] = useState<ReportRunResult | null>(null);

  const publish = (next: ReportRunResult) => {
    setResult(next);
    onRunStateChange?.(next);
  };

  return {
    open,
    result,
    running: result?.status === "running" && open,
    start: (headline: string) => {
      setOpen(true);
      publish(runningResult(headline));
    },
    publish,
    reopen: () => setOpen(true),
    close: () => setOpen(false),
  };
};
